import { forwardRef } from 'react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * A Button that shows a styled tooltip on hover.
 * Use `tooltip` prop for the label text.
 * Disabled buttons are wrapped in a span so pointer events still reach the trigger.
 */
const TooltipButton = forwardRef(({ tooltip, children, ...props }, ref) => (
  <Tooltip>
    <TooltipTrigger asChild>
      {/* span wrapper ensures disabled buttons still fire hover events */}
      <span className="inline-flex" tabIndex={props.disabled ? 0 : undefined}>
        <Button ref={ref} aria-label={tooltip} {...props}>
          {children}
        </Button>
      </span>
    </TooltipTrigger>
    <TooltipContent>
      <p>{tooltip}</p>
    </TooltipContent>
  </Tooltip>
));

TooltipButton.displayName = 'TooltipButton';

export { TooltipButton };
